/**
 * @generated SignedSource<<4e736672c3b813779242b73f792ea80b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EpisodeDetailPage_episode$data = {
  readonly audioS3Key: string;
  readonly chapters: ReadonlyArray<{
    readonly description: string | null | undefined;
    readonly endTimeMs: number;
    readonly id: string;
    readonly startTimeMs: number;
    readonly title: string;
  }>;
  readonly durationSeconds: number;
  readonly episodeId: string;
  readonly id: string;
  readonly publishedAt: any;
  readonly sourceLinks: ReadonlyArray<string>;
  readonly summary: string;
  readonly title: string;
  readonly topicSlug: string;
  readonly transcript: string;
  readonly " $fragmentType": "EpisodeDetailPage_episode";
};
export type EpisodeDetailPage_episode$key = {
  readonly " $data"?: EpisodeDetailPage_episode$data;
  readonly " $fragmentSpreads": FragmentRefs<"EpisodeDetailPage_episode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EpisodeDetailPage_episode",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "episodeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topicSlug",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcript",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationSeconds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "audioS3Key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceLinks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Chapter",
      "kind": "LinkedField",
      "name": "chapters",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTimeMs",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTimeMs",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Episode",
  "abstractKey": null
};
})();

(node as any).hash = "878c3ba2f196d780f163d60c3a845624";

export default node;
